export default [
  {
    country: 'United States',
    currency: 'usd',
    symbol: '\u0024',
  },
];
